import { render, staticRenderFns } from "./PXCreateQuestionModal.vue?vue&type=template&id=9023e7f4&scoped=true"
import script from "./PXCreateQuestionModal.vue?vue&type=script&lang=js"
export * from "./PXCreateQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./PXCreateQuestionModal.vue?vue&type=style&index=0&id=9023e7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9023e7f4",
  null
  
)

export default component.exports